import { render, staticRenderFns } from "./OrdersFBAEditUser.vue?vue&type=template&id=28eb555f&scoped=true"
import script from "./OrdersFBAEditUser.vue?vue&type=script&lang=js"
export * from "./OrdersFBAEditUser.vue?vue&type=script&lang=js"
import style0 from "./OrdersFBAEditUser.vue?vue&type=style&index=0&id=28eb555f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28eb555f",
  null
  
)

export default component.exports